import { MonoTypeOperatorFunction, tap } from 'rxjs';
import { isApiError } from '../../core/errors/api-error';
import { ApiErrorCode } from '../../core/errors/api-error-code';

/**
 * Reloads a user list after an account is created — also when the request failed with
 * `INVITATION_SEND_FAILED`, since the account was committed before its invitation went out.
 */
export function reloadOnAccountCreated<T>(reload: () => void): MonoTypeOperatorFunction<T> {
  return tap({
    next: reload,
    error: (error) => {
      if (isApiError(error, ApiErrorCode.INVITATION_SEND_FAILED)) reload();
    },
  });
}
